(function () {
  const selector = '.alireviews-review-star-rating';
  const pending = new Set();
  let frame = null;

  function update(wrapper) {
    if (!wrapper.isConnected || wrapper.dataset.croDone === '1') return;
    const ratingNode = wrapper.querySelector('.alr-wh-comp-list-star-rating');
    const countNode = wrapper.querySelector('.alr-wh-review-star-rating-number');
    if (!ratingNode || !countNode) return;
    const rating = ratingNode.getAttribute('data-star');
    const match = (countNode.textContent || '').match(/[\d,]+/);
    const count = match ? Number(match[0].replace(/,/g, '')) : NaN;
    if (!rating || !Number.isFinite(Number(rating)) || !Number.isFinite(count)) return;

    const copy = document.createElement('span');
    copy.className = 'alr-cro-copy';
    const ratingText = document.createElement('span');
    ratingText.className = 'alr-cro-rating';
    ratingText.textContent = rating + '/5';
    const countText = document.createElement('span');
    countText.className = 'alr-cro-count';
    countText.textContent = count.toLocaleString() + (count >= 100 ? '+' : '') + ' happy customers';
    copy.append('Rated ', ratingText, ' by ', countText);
    wrapper.dataset.croDone = '1';
    countNode.replaceChildren(copy);
  }

  function queue(wrapper) {
    if (!wrapper || wrapper.dataset.croDone === '1') return;
    pending.add(wrapper);
    if (frame !== null) return;
    frame = requestAnimationFrame(function () {
      frame = null;
      const batch = Array.from(pending);
      pending.clear();
      batch.forEach(update);
    });
  }

  function discover(node) {
    if (node.nodeType !== 1) return;
    queue(node.closest(selector));
    node.querySelectorAll(selector).forEach(queue);
  }

  function start() {
    document.querySelectorAll(selector).forEach(queue);
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        if (target) queue(target.closest(selector));
        record.addedNodes.forEach(discover);
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
